
export const registrationCharges = [
    {
        delegateType: "Delegate",
        earlyBird: 5250,
        standard: 6600,
        earlyOneDay: 2000,
        standardOneDay: 2640,
        registrationTypes: [
            "Delegate"
        ]
    },
    {
        delegateType: "Discounted (for Students and Persons with Disability)",
        earlyBird: 2650,
        standard: 3300,
        earlyOneDay: 1300,
        standardOneDay: 1650,
        registrationTypes : [ 
            "Student", 
            "Person with Disability"
        ]
    },
    {
        delegateType: "Accompanying Person #",
        earlyBird: 1300,
        standard: 1300,
        earlyOneDay: 660,
        standardOneDay: 660,
        registrationTypes: [
            "Accompanying Person"
        ]
    },
]

export const notes = [
    {
        note: "Last date of early bird registration is 25th September 2026",
        subNotes:[]
    },
    {
        note: "All charges are inclusive of GST (18%)",
        subNotes:[]
    },
    {
        note: "Regular registration includes",
        subNotes: [
            "Participation in all conference keynotes, workshops and thematic sessions",
            "Welcome Kit",
            "Lunch and tea during conference",
            "1 Banquet Dinner"
        ]
    },
    {
        note: "Limited fellowship for complimentary registration available for students and Person with disabilities.",
        subNotes: []
    },
    {
        note: "(*) One day registrations do not include Banquet dinner. However, dinner coupon can be purchased on the spot.",
        subNotes: []
    },
    {
        note: "(#) Accompanying persons registration only include lunch and tea during conference.",
        subNotes: []
    }
]


